/**
 * @param {Response|null|undefined} response
 * @returns {boolean}
 */
export function isUnauthorizedResponse(response) {
    return response?.status === 401;
}

/**
 * Marks session as expired and logs out. LoginScreen reads inactivityLogout for messaging.
 * @param {Function} [logout]
 */
export function handleUnauthorizedSession(logout) {
    sessionStorage.setItem('inactivityLogout', 'true');
    if (typeof logout === 'function') {
        logout();
    }
}

/**
 * If response is 401, logs out and returns true so callers skip local error UI.
 * @param {Response|null|undefined} response
 * @param {Function} [logout]
 * @returns {boolean}
 */
export function respondToUnauthorized(response, logout) {
    if (!isUnauthorizedResponse(response)) {
        return false;
    }
    handleUnauthorizedSession(logout);
    return true;
}
